import { FormGroup, FormBuilder } from '@angular/forms';
import { Injectable } from '@angular/core';
import { endpoints } from '../_config/endpoint';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UnitService {
  constructor(private http: HttpClient) {}
  createUnit(payload, divisionId) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createUnit}/${divisionId}/create`,
      payload
    );
  }

  getAllUnits() {
    return this.http.get(`${environment.API_URL_V1}/${endpoints.getAllUnits}`);
  }

  getAllUnitsByDivision(id) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllUnitsByDivision}/${id}/all`
    );
  }
  deleteUnit(unitId) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.deleteUnit}/${unitId}`
    );
  }
}
